
import { Component, Vue, Prop } from "vue-property-decorator";
import TemplateModal from "./template.vue";

@Component({
  components: {
    TemplateModal,
  },
})
export default class Logout extends Vue {
  @Prop({ default: 0 }) public modalId;
  @Prop({ default: 0 }) public textId;
  @Prop({ default: false }) public popupModalShow;
  public showModal = false;
  public modalRow = {};

  public async show(row?: any) {
    if (row) this.modalRow = row;
    this.$emit("update:popupModalShow", true);
  }

  public onConfirm(e) {
    if (this.modalId === 0) {
      // this.$emit("onConfirm");
    }
  }

  public closeModal() {
    this.$emit("update:popupModalShow", false);
  }
}
